export const useDarkMode = () => {
  const colorMode = useColorMode()

  const isDark = computed(() => colorMode.value === 'dark')

  const toggle = () => {
    colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
  }

  const setDark = (value: boolean) => {
    colorMode.preference = value ? 'dark' : 'light'
  }

  return {
    isDark,
    toggle,
    setDark
  }
}
